import { FC, Fragment, useCallback, useMemo } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

import {
  IProductionPollState,
  productionPollGroupStateAtom,
  productionPollStatesSelector,
  productionUiIdSelector,
} from "@ryde/shared";

import { ProductionChainsStatusBarStyled } from "./production-chains-status-bar.styled";
import {
  resolveNextChainIndex,
  resolveStepClassName,
} from "./production-chains-status-bar.utils";

export const ProductionChainsStatusBar: FC = () => {
  const states = useRecoilValue(productionPollStatesSelector);
  const productionUiId = useRecoilValue(productionUiIdSelector);
  const setGroupState = useSetRecoilState(productionPollGroupStateAtom);

  const nextChainIndex = useMemo(() => resolveNextChainIndex(states), [states]);

  const handleStepClick = useCallback(
    (productionId: number) => {
      setGroupState(prev =>
        prev ? { ...prev, productionUiId: productionId } : prev,
      );
    },
    [setGroupState],
  );

  if (states.length <= 1) {
    return null;
  }

  return (
    <ProductionChainsStatusBarStyled>
      {states.map((state: IProductionPollState, index: number) => (
        <Fragment key={state.productionId}>
          {index > 0 && <span className="chain-connector" />}
          <button
            type="button"
            className={resolveStepClassName({
              state,
              productionUiId,
              index,
              nextIndexToStart: nextChainIndex,
            })}
            onClick={() => handleStepClick(state.productionId)}
          >
            {index + 1}
          </button>
        </Fragment>
      ))}
    </ProductionChainsStatusBarStyled>
  );
};
